// extracted by mini-css-extract-plugin
export default {"toggleContainer":"iba-z","toggleBtn":"jba-z","toggleLabel":"kba-z","tooltipContainer":"lba-z","tooltipWrapper":"mba-z","tooltipContentTop":"nba-z"};